import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout/Layout";
import AdminMenue from "../../components/Layout/AdminMenu.js";
import axios from "axios";
import { useAuth } from "../../context/auth";
import moment from "moment";
import { Select } from "antd";

const { Option } = Select;
const AdminOrder = () => {
  const [status, setStatus] = useState([
    "Not Process",
    "Processing",
    "Shipped",
    "deliverd",
    "cancel",
  ]);
  const [changeStatus, setChangeStatus] = useState("");
  const [payment, setPayment] = useState(["Pending", "Completed"]);
  const [orders, setOrders] = useState([]);

  const [auth, setAuth] = useAuth();

  const getOrders = async () => {
    try {
      const { data } = await axios.get(`/api/v1/auth/all-orders`);

      setOrders(data.orders);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (auth?.token) {
      getOrders();
    }
  }, [auth?.token]);

  const handleChange = async (orderId, value) => {
    try {
      const { data } = await axios.put(`/api/v1/auth/order-status/${orderId}`, {
        status: value,
      });
      getOrders();
    } catch (error) {
      console.log(error);
    }
  };

  const handleChangePayment = async (orderId, value) => {
    try {
      const { data } = await axios.put(
        `/api/v1/auth/order-payment/${orderId}`,
        { payment: value }
      );
      getOrders();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <Layout title={" Admin- Orders"}>
      <div className="row">
        <div className="col-md-3">
          <AdminMenue />
        </div>
        <div className="col-md-9">
          <h1 className="text-center"> All Orders</h1>
          {orders?.map((o, i) => (
            <div className="border shadow" key={o._id}>
              <table className="table">
                <thead>
                  <tr>
                    <th scope="col">S.N</th>
                    <th scope="col">Status</th>
                    <th scope="col">Buyer</th>
                    <th scope="col">Date</th>
                    <th scope="col">Payment</th>
                    <th scope="col">Quantity</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{i + 1}</td>
                    <td>
                      <Select
                        bordered={false}
                        onChange={(value) => handleChange(o._id, value)}
                        defaultValue={o?.status}
                      >
                        {status.map((sts, index) => (
                          <Option key={index} value={sts}>
                            {" "}
                            {/* Fix: use sts instead of status */}
                            {sts}
                          </Option>
                        ))}
                      </Select>
                    </td>

                    <td>{o?.buyer?.name}</td>
                    <td>{moment(o?.createdAt).fromNow()}</td>
                    <td>
                      <Select
                        bordered={false}
                        onChange={(value) => handleChangePayment(o._id, value)}
                        defaultValue={o?.payment}
                      >
                        {payment.map((pay, index) => (
                          <Option key={index} value={pay}>
                            {pay}
                          </Option>
                        ))}
                      </Select>
                    </td>
                    <td>{o?.products?.length}</td>
                  </tr>
                </tbody>
              </table>
              <div className="container">
                {o?.products?.map((p, j) => (
                  <div className="row mb-2 p-3 card flex-row" key={p._id}>
                    <div className="col-md-4">
                      <img
                        src={`/api/v1/product/product-photo/${p._id}`}
                        className="card-img-top"
                        alt={p.name}
                        style={{ height: "200px", width: "300px" }}
                      />
                    </div>
                    <div className="col-md-8">
                      <p>{p.name}</p>
                      <p>{p.description.substring(0, 30)}</p>
                      <p>Price: {p.price}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
};

export default AdminOrder;
